"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const react_1 = __importStar(require("react"));
const WidgetButton_1 = __importDefault(require("./formControls/WidgetButton"));
const Button_1 = __importDefault(require("@mui/material/Button"));
function foodBeverage(props) {
    const [expanded, setExpanded] = (0, react_1.useState)(false);
    const [userInteracted, setUserInteracted] = (0, react_1.useState)(false);
    const [selectedPackage, setSelectedPackage] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        console.log("selectedPackage useEffect", selectedPackage);
        props.onSelectPackage(selectedPackage ? selectedPackage.uid : null);
    }, [selectedPackage]);
    const handleSelectPackage = (packageUid) => {
        setUserInteracted(true);
        const selectedPackage = props.packages.find((packageItem) => packageItem.uid == packageUid);
        setSelectedPackage(selectedPackage !== null && selectedPackage !== void 0 ? selectedPackage : null);
        props.onSelectPackage(packageUid);
    };
    let visiblePackages = [];
    const z = props.packages.filter((packageItem) => packageItem.uid == (selectedPackage === null || selectedPackage === void 0 ? void 0 : selectedPackage.uid));
    if (selectedPackage && z.length == 0) {
        console.log("selectedPackage not found in props.packages", selectedPackage);
        setSelectedPackage(null);
    }
    if (expanded || userInteracted) {
        visiblePackages = props.packages;
    }
    else {
        if (z.length > 0) {
            visiblePackages = z;
        }
        else {
            //Find default
            const defaultPackage = props.packages.find((packageItem) => packageItem.default);
            if (defaultPackage) {
                setSelectedPackage(defaultPackage);
                visiblePackages = [defaultPackage];
            }
            else {
                //If no default, select first
                setSelectedPackage(props.packages[0]);
                visiblePackages = [props.packages[0]];
            }
        }
    }
    return (react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
        react_1.default.createElement(material_1.Stack, null,
            react_1.default.createElement(material_1.Grid, { container: true, width: "100%" }, visiblePackages.map((packageItem) => (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, key: packageItem.uid },
                react_1.default.createElement(WidgetButton_1.default, { onClick: () => handleSelectPackage(packageItem.uid), selected: packageItem.uid === (selectedPackage === null || selectedPackage === void 0 ? void 0 : selectedPackage.uid), height: 70 },
                    react_1.default.createElement(material_1.Stack, null,
                        react_1.default.createElement(material_1.Typography, { variant: "body1" },
                            react_1.default.createElement("strong", null,
                                packageItem.title,
                                " | $",
                                packageItem.cost,
                                packageItem.pp == 1 && react_1.default.createElement("span", null, " pp"),
                                packageItem.pp == 1 && packageItem.ph == 1 && react_1.default.createElement("span", null, " / "),
                                packageItem.ph == 1 && react_1.default.createElement("span", null, " ph"))),
                        react_1.default.createElement(material_1.Typography, { variant: "body2" }, packageItem.description))))))),
            !expanded && !userInteracted && props.packages.length > 1 && (
            //<Button height={70} onClick={() => setExpanded(true)}>Show All</Button>
            react_1.default.createElement(Button_1.default, { onClick: () => setExpanded(true) }, "Show all options")))));
}
exports.default = foodBeverage;
